module.exports = __webpack_public_path__ + "img/erika-round.67d02277.png";